<mat-drawer-container style="background: var(--background); display: initial;">
  <form [formGroup]="allForm" style="display: flex;min-height: 100vh;">


    <div style="flex: 1;padding: 0 40px">

      <div style="display: flex;justify-content: space-between;margin-bottom: 32px;margin-top: 32px">

        <div class="title-large" data-testid="pageTitle" style="display: flex;align-items: center; gap: 8px">
          <span (click)="onBackClick.emit()" class="material-symbols-rounded"
                style="cursor: pointer;padding: 6px">west</span>
          @if (data().currentInHubMessage) {
            Edit app message
          } @else {
            New app message
          }
        </div>

        <div style="display: flex;align-items: center; gap:8px">

          <img [ngSrc]="'../'+Bu.getBu(data().bu).flagUrl" alt="flag" height="24" width="24">
          {{ Bu.getBu(data().bu).buName }}
        </div>

      </div>

      <div style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_uk.png" sizes="24" width="24">
          English message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="englishTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="englishLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="englishMessage" rows="3"></textarea>
          </div>
        </div>
      </div>


      <div style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_sweden.svg" sizes="24" width="24">
          Swedish message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="swedishTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="swedishLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="swedishMessage" rows="3"></textarea>
          </div>
        </div>
      </div>
    </div>


    <div style="flex: 1;background: var(--card-background);padding: 0 40px">


      <div class="title-large" style="margin-bottom: 32px;margin-top: 32px">
        Settings
      </div>
      <div class="form-group">
        <label>Visible</label>
        <select formControlName="displayRoute">
          @for (route of hubRoutes; track route; let i = $index; ) {
            <option [value]="route.value">{{ route.text }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label>Message functions</label>
        <div>
          <p>
            <input formControlName="dismissible" type="checkbox">Dismissible
          </p>
          <p>
            <input formControlName="link" type="checkbox">Enable external link below (paired with "Link label” field)
          </p>
        </div>
      </div>

      <div class="form-group">
        <label for="link">Url</label>
        <input formControlName="externalUrl" id="link">
      </div>
    </div>
  </form>
  <div class="fab-container">
    <div style="display: flex;gap: 8px">
      <button (click)="translateWithAI()" class="secondary-button" data-testid="autoTranslateButton">Auto translate
      </button>
    </div>

    <button (click)="createMessage() && onSubmitClick.emit()" [disabled]="!allForm.valid" class="primary-button"
            data-testid="publishButton">Publish
    </button>
  </div>
</mat-drawer-container>
